import { render, staticRenderFns } from "./HekimTanimlama.vue?vue&type=template&id=62616dd9&"
import script from "./HekimTanimlama.vue?vue&type=script&lang=js&"
export * from "./HekimTanimlama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports